import {
  getSolutionHotSearch
} from '@/api/solutions/solution'
import {
  getColumnList
} from '@/api/news/news'
import {
  getAdvertising
} from '@/api/common'

const state = {
  hotSolutions: [], // 首页热搜方案存储 最多8条
  hkjNews: [], // 黑科技
  fajxNews: [], // 方案解析
  yxsjsNews: [], // 优秀设计师
  hyghNews: [], // 行业干货
  advertising1: [],
  advertising2: []
}
const actions = {
  /* 首页方案热搜 */
  HOME_HOT_SEARCH_SOLUTIONS ({ commit }) {
    let params = {
      pageNum: 1,
      pageSize: 8
    }
    getSolutionHotSearch(params).then(result => {
      if (result && result.status === 200 && result.data && result.data.code === 200 && result.data.data) {
        commit('HOME_SET_HOT_SOLUTIONS', result.data.data.list)
      }
    })
  },
  // 根据标签名称查询资讯信息
  HOME_GET_NEWS_BY_TAGNAME ({ commit }, params) {
    getColumnList(params).then(result => {
      if (result && result.status === 200 && result.data && result.data.code === 200 && result.data.data) {
        let data = {
          list: result.data.data.list,
          type: params.tagName
        }
        commit('HOME_SET_NEWS', data)
      }
    })
  },
  // 获取广告信息
  HOME_GET_ADVERTISING_1 ({ commit }) {
    getAdvertising('msolution_1').then(result => {
      if (result.status === 200 && result.data && result.data.code === 200 && result.data.data) {
        commit('HOME_SET_ADVERTISING', { type: 'msolution_1', list: result.data.data })
      }
    })
  },
  // 获取广告信息
  HOME_GET_ADVERTISING_2 ({ commit }) {
    getAdvertising('msolution_2').then(result => {
      if (result.status === 200 && result.data && result.data.code === 200 && result.data.data) {
        commit('HOME_SET_ADVERTISING', { type: 'msolution_2', list: result.data.data })
      }
    })
  }
}

const mutations = {
  // 设置首页热搜方案数据
  HOME_SET_HOT_SOLUTIONS (state, data) {
    state.hotSolutions = data
  },
  // 设置资讯
  HOME_SET_NEWS (state, data) {
    if (data.type && data.type.indexOf('黑科技') > -1) {
      state.hkjNews = data.list
    }
    if (data.type && data.type.indexOf('方案解析') > -1) {
      state.fajxNews = data.list
    }
    if (data.type && data.type.indexOf('优秀设计师') > -1) {
      state.yxsjsNews = data.list
    }
    if (data.type && data.type.indexOf('行业干货') > -1) {
      state.hyghNews = data.list
    }
  },
  // 设置广告数据
  HOME_SET_ADVERTISING (state, data) {
    if (data.type === 'msolution_1') {
      state.advertising1 = data.list
    }
    if (data.type === 'msolution_2') {
      state.advertising2 = data.list
    }
  }
}
const getters = {}

export default {
  state,
  actions,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/home/home.js